import { render, staticRenderFns } from "./notYetOpen.vue?vue&type=template&id=8dd4f8fa&scoped=true&"
import script from "./notYetOpen.vue?vue&type=script&lang=js&"
export * from "./notYetOpen.vue?vue&type=script&lang=js&"
import style0 from "./notYetOpen.vue?vue&type=style&index=0&id=8dd4f8fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4f8fa",
  null
  
)

export default component.exports